import { apiClient } from '../api';
import { Path } from '../api/backendUrl';

export const getProviderById = async (id: string) => {
  try {
    const res = await apiClient.get(
      `${import.meta.env.VITE_APP_BACKEND_USER}/${Path.getProvider}` + `/${id}`
    );
    return res.data;
  } catch (error: unknown) {
    console.log('ERROR: ', error);
    // logger.error(error);
    throw error;
  }
};

export const getProviderByIds = async (ids: string[]) => {
  try {
    const res = await apiClient.post(
      `${import.meta.env.VITE_APP_BACKEND_USER}/${Path.getUserByIds}`,
      { ids }
    );
    return res.data;
  } catch (error: unknown) {
    console.log('ERROR: ', error);
    // logger.error(error);
    throw error;
  }
};

// GET PORTFOLIO BY DETAILS
export const getProviderPortfolioCardDetails = async (
  id: string,
  page: number,
  limit: number
) => {
  try {
    const quary = `?businessId=${id}&isActive=true&page=${page}&limit=${limit}`;
    const res = await apiClient.get(
      `${import.meta.env.VITE_APP_BACKEND_SERVICE}/${Path.getProviderJobCard}` +
        `${quary}`
    );
    return res.data;
  } catch (error: unknown) {
    console.log('ERROR: ', error);
    // logger.error(error);
    throw error;
  }
};

// https://api.staging.gigmosaic.ca/service/api/v1/jobcard?serviceId=xxx&isActive=true&page=1&limit=10

// GET BUSINESS SETTINGS
export const getBusinessSettings = async ({ id, keys }: any) => {
  try {
    // Replace path param
    let url = Path.businessSettingsGet.replace(':providerId', id);
    console.log('URL: ', url);
    //  businessSettingsGet: "user/api/v1/provider-meta/provider/:providerId",
    // Append query params if provided
    if (keys && Object.keys(keys).length > 0) {
      const queryString = new URLSearchParams(
        Object.entries(keys).reduce(
          (acc, [key, val]) => {
            acc[key] = String(val);
            return acc;
          },
          {} as Record<string, string>
        )
      ).toString();

      url += `?${queryString}`;
    }
    console.log('FINAL URL: ', url);
    const res = await apiClient.get(
      import.meta.env.VITE_APP_BACKEND_USER + url
    );
    return res.data;
  } catch (error) {
    console.error('Error fetching business settings:', error);
    throw error;
  }
};

// https://api.staging.gigmosaic.ca/user/api/v1/user/by-slug/:slug

//GET PROVIDER BY SLUG
export const getProviderDetailsByProvider = async (id: string) => {
  console.log('Param: ', id);
  try {
    const url =
      `${import.meta.env.VITE_APP_BACKEND_USER}/${Path.getProviderDetailsBySlug}`.replace(
        ':slug',
        id
      );
    const res = await apiClient.get(url);

    // if (res?.data?.success) return res.data.user;
    if (res?.data?.success) return res.data.user;
  } catch (error: any) {
    const errorCode = error.response?.data?.code;
    console.log('ERROR get user details by slug: ', error);
    if (errorCode === 404) {
      window.location.replace('/');
      return;
    }
    throw error;
  }
};

/**
 * Fetch business details by slug — multi-business support (§5.5).
 * Wraps the business-specific endpoint; during backend transition,
 * may delegate to getProviderDetailsByProvider.
 */
export const getBusinessDetailsBySlug = async (slug: string) => {
  try {
    const url =
      `${import.meta.env.VITE_APP_BACKEND_USER}/${Path.getBusinessBySlug}`.replace(
        ':businessSlug',
        slug
      );
    const res = await apiClient.get(url);
    if (res?.data?.success) return res.data.business ?? res.data;
    return res.data;
  } catch (error: any) {
    console.error(
      'Business endpoint not available, falling back to provider-by-slug',
      error?.message || error
    );

    throw error;
  }
};
